import { api } from "@services/baseURL";

export const SaveTemplateEmail = async (data) => {
  try {
    const response = await api.post('TemplatesEmail', data);
    return response.data;
  } catch (error) {
    console.error('Erro ao salvar template de email:', error);
    throw error;
  }
};

export const UpdateTemplateEmail = async (id, data) => {
  try {
    const response = await api.patch(`TemplatesEmail/${id}`, data);
    return response.data;
  } catch (error) {
    console.error('Erro ao atualizar template de email:', error.response?.data || error.message);
    throw error;
  }
};

export const DeleteTemplateEmail = async (id) => {
  try {
    await api.delete(`TemplatesEmail/${id}`);
    return true;
  } catch (error) {
    console.error('Erro ao deletar template de email:', error);
    throw error;
  }
};

export const GetAllTemplatesEmails = async (pageSize, rowsPerPage, filters = {}) => {
  try {
    const response = await api.get('TemplatesEmail', {
      headers: {
        Authorization: `Bearer authToken`,
      },
      params: {
        pageNumber: pageSize,
        pageSize: rowsPerPage,
        ...filters,
      },
    });
    return response.data;
  } catch (error) {
    console.error('Erro ao buscar todos templates de emails:', error);
    throw error;
  }
};

export const GetByIdTemplateEmail = async (id) => {
  try {
    const response = await api.get(`TemplatesEmail/${id}`);
    return response.data;
  } catch (error) {
    console.error('Erro ao buscar template de email:', error);
    throw error;
  }
};

export default {
  SaveTemplateEmail,
  UpdateTemplateEmail,
  DeleteTemplateEmail,
  GetByIdTemplateEmail,
  GetAllTemplatesEmails
};